<template>
<div class="form-designer-component">
    <div class="mcc-page-header" v-if="!isStandalone && !noFormData">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <div>
                    <section class="mu-d-flex mu-w-100">
                        <h1 class="mu-mb-00">{{title}}</h1>
                    </section>
                </div>
                <section>
                    <div role="group" class="mcc-button-group mcc-button-group--spaced no-print" v-show="fetchCall">

                        <button class="mcc-button mcc-button--soft-success" id="saveForLaterBtn" name="saveForLaterBtn" title="Save as draft" @click="handleSaveForLater()">
                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save as draft</span>
                        </button>
                        <button class="mcc-button mcc-button--soft-primary" v-if="drafts.length > 0" id="loadFromDraftdBtn" @click="handleLoadDraftBtnClick()" name="loadFromDraftdBtn" title="Load from draft">
                            <mcc-icon name="approval" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Load from draft</span>
                        </button>
                        <button class="mcc-button mcc-button--outline icon_only_btn" id="printForm" name="printForm" title="Print" @click="handlePrintForm()">
                            <mcc-icon name="print" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Print</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-page-header mcc-page-header-standalone" v-if="isStandalone && !isExternal && !noFormData">
        <section class="mu-d-flex mu-flex-column">
            <h1 class="mu-mb-00"></h1>
        </section>
        <section>
            <div role="group" class="mcc-button-group mcc-button-group--spaced" v-show="fetchCall">
                <button class="mcc-button mcc-button--soft-success" id="saveForLaterBtn" name="saveForLaterBtn" title="Save as draft" @click="handleSaveForLater()">
                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save as draft</span>
                </button>
                <button class="mcc-button mcc-button--soft-primary" v-if="drafts.length > 0" id="loadFromDraftdBtn" @click="handleLoadDraftBtnClick()" name="loadFromDraftdBtn" title="Load from draft">
                    <mcc-icon name="approval" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Load from draft</span>
                </button>
            </div>
        </section>
    </div>
    <div :class="isStandalone ? 'mcc-container-fluid card-padding mcc-row-standalone' : 'mcc-container-fluid card-padding'">
        <div  v-if="!isStandalone && !noFormData">
            <nav aria-label="breadcrumb" >
                <ol class="mcc-breadcrumb">
                    <li>{{defCategory}}</li>
                    <li>{{title+" ("+definitionId+")"}}</li>
                </ol>
            </nav>
        </div>
        <div style="position:relative">
            <div id="typeahead-repeatable-wait" class="spinner-overlay d-none">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div id="typeahead-wait" class="spinner-overlay d-none">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-if="fetchCall">
                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card" v-if="!noFormData">
                            <div class="mcc-card__body">
                                <div class="mcc-row" v-if="isExternal">
                                    <div class="mcc-col">
                                        <form novalidate ref="processForm" @submit="handleFormSubmit($event)" enctype="multipart/form-data" id="rendererForm" method="post" prevent-default captcha>
                                            <div id="render-canvas"></div>
                                            <div v-if="definitionObj">
                                                <div id="recaptcha"></div>
                                                <span id="invalid-captcha"></span>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="mcc-row" v-if="!isExternal">
                                    <div class="mcc-col">
                                        <form novalidate ref="processForm" @submit="handleFormSubmit($event)" enctype="multipart/form-data" id="rendererForm" method="post" prevent-default>
                                            <div id="render-canvas"></div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" id="apiLookupSelectDataDialog" ref="apiLookupSelectDataDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Select value</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeApiLookupValue()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mfc-slim-select-wrapper mu-mb-03">
                            <select ref="dataArrayAPI" no-search id='dataArraySelectCmp' name="dataArrayAPI" block label="Select value" class="mfc-slim-select">
                                <option value="">Select an option</option>
                            </select>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeApiLookupValue()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="setApiLookupValue($event)">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog id="editGridPopup" ref="editGridPopup" class="mcc-dialog mcc-dialog--primary mcc-dialog--xs">
            <section>
                <form novalidate>
                    <div class="spinner-overlay d-none" id="grid-popup-wait">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                        </div>
                    </div>
                    <div class="mcc-dialog__header">
                        <h2 class="h4"></h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeEditGridDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="row" id="grid-popup-content">
                            <div class="col">
                                <div class="mfc-input-wrapper">
                                    <input type="hidden" id="mode" name="" value="add">
                                    <input type="hidden" id="activeIndex" name="" value="-1">
                                </div>
                                <div class="container-fluid dataDiv" id="dataDiv">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeEditGridDialog()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" id="saveGridBtn">Ok</button>
                        </div>
                    </div>
                </form>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">

        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--primary" id="saveForLaterDialog" ref="saveForLaterDialog">
            <form novalidate id="saveAsDraftForm">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Save as draft</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div style="position:relative">
                            <div v-if="!updateDraftCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div v-if="updateDialog">
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                            <label for="partialFormInfoName" class="mfc-label--required">Name</label>
                                            <input type="text" name="partialFormInfoName" id="partialFormInfoName" required="" maxlength="50" :value="partialFormInfoName" @change="updateName($event)" ref="partialFormInfoName" :pattern="nameRegex">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDialog()">Close</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="saveForLater()">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">

        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--primary" id="loadFromDraftDialog" ref="loadFromDraftDialog">
            <form @submit.prevent="loadFromDraft($event)" id="loadForm" novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Load from draft</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDraftsDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div style="position:relative">
                            <div v-if="!updateDraftCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div v-if="updateDraftListDialog">
                                        <div class="mfc-slim-select-wrapper mu-mb-03 mu-position-relative dialogSlimSelect mfc-form-input-container">
                                            <label for="draftList" class="mfc-label--required">Select draft</label>
                                            <div id="InvolvingselectIdDiv"></div>
                                            <select required id="draftList" @change="selectedDraft = $event.target.value" name="draftList" block label="Select draft" class="mfc-slim-select">
                                                <option value="" :selected="selectedDraft == ''">Select an option</option>
                                                <option v-for="(draft,key) in drafts" :selected="selectedDraft == draft.id" :key="key" :value="draft.id">{{draft.name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDraftsDialog()">Close</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Load</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import MyProcessListAPI from "../../services/MyProcessListAPI";
import MyTaskListAPI from "../../services/MyTaskListAPI";
import AdminHttpAPI from "../../services/AdminHttpAPI";
import Utils from "../../script_utils";
import CustomDataList from "../../bindCustomDataList";
import APILookupUtils from "../../apilookup";
import TypeaheadUtils from "../../typeahead_utils";
import RepeatableUtils from "../../repeatable_utils";
import GridUtils from "../../grid_utils";
import constants from "../../constants";
import constantMessages from "../../messages";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../formvalid.js';

import {
    EventBus
} from "../../services/event-bus";
export default {
    name: "ViewProcess",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: false,
            definitionId: "",
            definitionObj: null,
            definitionName: "",
            formActionURL: "",
            updateCall: true,
            updateDraftCall: true,
            isStandalone: false,
            defCategory: "Home",
            isExternal: false,
            partialFormInfoDTO: {},
            newPartialFormInfoDTO: {},
            partialFormInfoName: "",
            updateDialog: false,
            oldDraftName: "",
            updateDraftListDialog: false,
            selectedDraft: '',
            drafts: [],
            nameRegex: constantMessages.PATTERNS["customName"],
            variableList: "",
            variableMap: [],
            dataJSON: "{}",
            noFormData: false
        };
    },
    created() {
        window.signaturePad = {};
        this.title = "";
        if (this.$route.params.standalone && this.$route.params.standalone == "standalone") {
            this.isStandalone = true;
        }
        if (this.$route.params.external && this.$route.params.external == "external") {
            this.isExternal = true;
        }
        if (this.isExternal) {
            this.formActionURL =
                constants.BASE_URL +
                "/standalone/external/processesAPI/startWithDropzone/processDefinitionId/" +
                this.$route.params.definitionId;
        } else {
            this.formActionURL =
                constants.BASE_URL +
                "/processesAPI/startWithDropzone/processDefinitionId/" +
                this.$route.params.definitionId;
        }
        this.definitionId = this.$route.params.definitionId;
    },
    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit')
        document.head.appendChild(recaptchaScript)

        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        if (self.$route.query.draftId && self.$route.query.draftId != "" && self.$route.query.draftId != null) {
            self.selectedDraft = self.$route.query.draftId;
        }
        MyProcessListAPI.getFormForProcesses(this.definitionId, this.isExternal)
            .then(result => {
                if (result.formRenderJson == null || result.formRenderJson == "") {
                    self.noFormData = true;
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES["error.process.deployment"]
                    });
                } else {
                    self.noFormData = false;
                }
                self.definitionObj = result;
                self.definitionName = result.definitionInfo != null ? result.definitionInfo.name : self.definitionId;
                self.title = self.definitionName;
                self.defCategory = result.definitionInfo != null && result.definitionInfo.category != null && result.definitionInfo.category != "" ? result.definitionInfo.category : "Home";
                self.fetchCall = true;
                let pageTitle = self.title;
                if (this.isStandalone) {
                    pageTitle = constantMessages.PAGEHEADER_TITLE["menu.design.processes"] + " - " + self.title;
                }
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                if (self.selectedDraft != "") {
                    self.getDraftData();
                } else if (self.definitionObj != null && self.definitionObj.formRenderJson != "") {
                    self.generateForm(self.definitionObj.formRenderJson, false);
                }
            });
        if (!this.isExternal) {
            MyProcessListAPI.getDraftList(self.extractdefinitionId(this.definitionId))
                .then(response => {
                    if (response) {
                        self.drafts = response;
                    }
                });
        }
        window.recaptchaCallback = this.recaptchaCallback;
    },
    methods: {
        showDialog() {
            this.updateDialog = true;
        },
        closeDialog() {
            $('#saveForLaterDialog')[0].close();
            this.updateDialog = false;
        },
        showDraftsDialog() {
            if (this.partialFormInfoDTO != null) {
                this.selectedDraft = this.partialFormInfoDTO.id;
            } else {
                this.selectedDraft = "";
            }
            this.updateDraftListDialog = true;
        },
        closeDraftsDialog() {
            $('#loadFromDraftDialog')[0].close();
            this.updateDraftListDialog = false;
        },
        recaptchaCallback() {
            if (this.definitionObj == null) {
                setTimeout(recaptchaCallback, 250);
                return;
            }
            if (this.isExternal) {
                grecaptcha.render("recaptcha", {
                    sitekey: this.definitionObj.recaptchaKey,
                    callback: function () {
                        $("#invalid-captcha").text("");
                    }
                });
            }
        },
        closeApiLookupValue() {
            $('#apiLookupSelectDataDialog')[0].close()
        },
        closeEditGridDialog() {
            $('#editGridPopup').parent().removeClass("mu-visible");
            $('#editGridPopup')[0].close();
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.required"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");              
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.length"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");            
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");            
            }
            self.partialFormInfoName = event.target.value;
        },
        handleSaveForLater() {
            this.partialFormInfoName = this.oldDraftName;
            this.showDialog()
            $("#saveForLaterDialog")[0].show();
        },
        saveForLater() {
            let self = this;
            let form = $('#saveAsDraftForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let url = "update";
            self.updateCall = false;
            let disabled = $(this.$refs.processForm).find(':disabled').removeAttr('disabled');
            let formData = $(this.$refs.processForm).serializeArray();
            disabled.attr('disabled', 'disabled');
            let formDataArray = [];
            self.updateDraftCall = false;
            Utils.updateFormDataForCheckbox(formData, formDataArray);
            let partialFormDatas = [];
            Utils.updateDateValuesForDraft(formDataArray);
            for (let key in formDataArray) {
                let partialFormData = {};
                if (TypeaheadUtils.isTypeahead(formDataArray[key].name)) {
                    let formValue = TypeaheadUtils.getTypeAheadFieldValue(
                        TypeaheadUtils.getElementByName(formDataArray[key].name)
                    );
                    partialFormData.varName = formDataArray[key].name;
                    partialFormData.varValue = formValue;
                } else {
                    partialFormData.varName = formDataArray[key].name;
                    partialFormData.varValue = formDataArray[key].value;
                }
                if (!partialFormData.varName.startsWith("oldRepeatableRow") && partialFormData.varName != "oldGridRow") {
                    partialFormDatas.push(partialFormData);
                }
            }
            if (self.oldDraftName != self.partialFormInfoName) {
                self.newPartialFormInfoDTO.processDefinitionId = self.extractdefinitionId(self.definitionId);
                self.newPartialFormInfoDTO.processDefinitionName = self.definitionName;
                self.newPartialFormInfoDTO.name = self.partialFormInfoName;
                url = "save";
            } else {
                self.newPartialFormInfoDTO = self.partialFormInfoDTO;
            }
            self.newPartialFormInfoDTO.partialFormDatas = partialFormDatas;
            MyTaskListAPI.saveForLater(url, self.newPartialFormInfoDTO)
                .then(response => {
                    self.updateDraftCall = true;
                    if (response) {
                        if (response.data == "error.input.owasp.error") {
                            displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES[response.data])
                            self.$refs.partialFormInfoName.classList.add("ms-is-invalid")
                        } else if (response.data == "error.forbidden" || response.data == "error.save.partialFormData" || response.data == "error.update.partialFormData") {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.data]
                            });
                        } else {
                            self.partialFormInfoDTO = response;
                            self.oldDraftName = self.partialFormInfoDTO.name;
                            $("#saveForLaterDialog")[0].close();
                            if (url == "save") {
                                let newDraft = {};
                                newDraft.id = self.partialFormInfoDTO.id;
                                newDraft.name = self.partialFormInfoDTO.name;
                                self.drafts.push(newDraft);
                                self.selectedDraft = self.partialFormInfoDTO.id;
                            }

                            if (self.isStandalone) {
                                EventBus.$emit("success-notification", {
                                    msg: constantMessages.MESSAGES["process.draft.save.success.standalone"]
                                });
                            } else {
                                EventBus.$emit("success-notification", {
                                    msg: constantMessages.MESSAGES["process.draft.save.success"]
                                });
                            }
                        }
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        },
        extractdefinitionId(definitionId) {
            if (definitionId.includes(".")) {
                return definitionId.split(".")[0];
            } else {
                return definitionId;
            }
        },
        generateForm(formJson, isDraft) {
            this.updateCall = false;
            setTimeout(() => {
                window.generatePreview(JSON.parse(formJson), $("#render-canvas"), 1);
                if (isDraft) {
                    this.afterFormRenderForDraft();
                } else {
                    this.afterFormRender();
                }
            }, 0)
        },
        afterFormRender() {
            let self = this;
            $("#render-canvas .dropzone").each(function () {
                Utils.bindDropzone(this, $(this).attr("name"), self.formActionURL, true);
            });
            Utils.applyFileUploadValidations("render-canvas");
            CustomDataList.populateDataListData();
            this.populateAPILookup();
            setTimeout(function () {
                self.setCanvasSize();
                RepeatableUtils.renderRepeatableRows("{}");
                setTimeout(() => {
                    // $("#rendererForm")[0].update();
                    // window.applyDecimalValidation($("#render-canvas"), false);
                }, 0);
                GridUtils.renderEditableGrid('{}');
                setTimeout(function () {
                    // TypeaheadUtils.updateTypeAheadData();
                    if ($("[data-grid='true']") == null || $("[data-grid='true']").length == 0) {
                        TypeaheadUtils.updateDynamicTypeAheadData().then(() => {
                            self.updateCall = true;
                        });
                    }
                }, 0);
                if ($("[data-grid='true']") != null && $("[data-grid='true']").length > 0) {
                    self.updateCall = true;
                }
            }, 2000);
        },
        setCanvasSize() {
            $('canvas').each((i, Ele) => {
                let canvasEle = $(Ele);
                let offsetWidth = canvasEle[0].offsetWidth;
                if (offsetWidth != 0) {
                    $(Ele).attr("width", canvasEle[0].offsetWidth);
                    $(Ele).attr("height", canvasEle[0].offsetHeight);
                }
            });
        },
        afterFormRenderForDraft() {
            let self = this;
            $("#render-canvas .dropzone").each(function () {
                Utils.bindDropzone(this, $(this).attr("name"), self.formActionURL, true);
            });
            Utils.applyFileUploadValidations("render-canvas");
            CustomDataList.populateDataListData();
            this.populateAPILookup();
            setTimeout(function () {
                self.setCanvasSize();
                Utils.updateFormUsingProcessVariables(self.variableList,
                    self.variableMap
                );
                RepeatableUtils.renderRepeatableRows(self.dataJSON);
                setTimeout(() => {
                    window.applyDecimalValidation($("#render-canvas"), false);
                }, 0);
                GridUtils.renderEditableGrid(self.dataJSON);
                setTimeout(function () {
                    TypeaheadUtils.updateTypeAheadData();
                }, 0);
                self.updateCall = true;
            }, 2000);
        },
        populateAPILookup() {
            $("#render-canvas").find(".form-group.row[apilookupcontainer]").find("button").each(function () {
                $(this).on('click', () => {
                    APILookupUtils.renderApiLookupDataField(this);
                })
            });
        },
        async handleLoadDraftBtnClick() {
            this.showDraftsDialog()
            await $("#loadFromDraftDialog")[0].show();
            new SlimSelect({
                select: '#draftList',
                settings: {
                    contentPosition: 'absolute',
                    contentLocation: document.getElementById('InvolvingselectIdDiv')
                }
            })
        },
        loadFromDraft(e) {
            let form = $('#loadForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            
            this.closeDraftsDialog();
            $(this.$refs.processForm)[0].reset();
            this.oldDraftName = "";
            this.variableList = "";
            this.dataJSON = "{}";
            this.getDraftData();
        },
        getDraftData() {
            let self = this;
            if (self.selectedDraft != '') {
                self.updateCall = false;
                self.updateDraftCall = false;
                MyProcessListAPI.getDraftById(self.selectedDraft)
                    .then(response => {
                        self.updateDraftCall = true;
                        if (response) {
                            self.partialFormInfoDTO = response.partialFormInfoDTO;
                            self.oldDraftName = self.partialFormInfoDTO.name;
                            self.variableList = response.variableList;
                            self.dataJSON = response.dataJSON;
                            self.generateForm(self.definitionObj.formRenderJson, true)
                        }
                    });
            }
        },

        switchTab(e) {
            $("#" + $("#" + document.querySelectorAll(":invalid")[1].id).parents(".newClass")[0].id).trigger('click');
            $("#" + document.querySelectorAll(":invalid")[1].id).focus();
        },
        handleFormSubmit(e) {
            let self = this;
            if (self.isExternal) {
                let recaptcha = grecaptcha.getResponse();
                if (recaptcha.length == 0) {
                    $("#invalid-captcha").text("Captcha check is required");
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
            }
            // let mosaicData = e.detail.data;
            let form = $(this.$refs.processForm);
            let formDataArray = form.serializeArray();
            if (e.submitter.attributes.ignoreformvalidation === undefined) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            let ignoreValidation = e.submitter.attributes.ignoreformvalidation.value;
            if (!form[0].checkValidity() && ignoreValidation != 'true') {
                e.preventDefault();
                e.stopPropagation();
                form.addClass('ms-was-validated');
                this.switchTab(e);
            } else {
                let form_data = new FormData();
                // Utils.updateDatepickerValues(mosaicData, formDataArray);
                if (Utils.appendDropzoneDataExternal(form_data) && TypeaheadUtils.validateValueOfTypeahead() && TypeaheadUtils.validateTypeaheadMinValues() && Utils.validateEditableGrid()) {
                    this.updateCall = false;
                    let fileInputs = $("#rendererForm input[type=file]");
                    for (const fileInput of fileInputs) {
                        for (const file of fileInput.files) {
                            form_data.append(fileInput.name, file);
                        }
                    }
                    for (let key in formDataArray) {
                        if (TypeaheadUtils.isTypeahead(formDataArray[key].name)) {
                            let formValue = TypeaheadUtils.getTypeAheadFieldValue(
                                TypeaheadUtils.getElementByName(formDataArray[key].name)
                            );
                            if ($('[name="' + formDataArray[key].name + '"]').find("input").length > 0 && $('[name="' + formDataArray[key].name + '"]').find("input").attr("type") == "number") {
                                form_data.append(formDataArray[key].name + "_type", "double");
                            }
                            form_data.append(formDataArray[key].name, formValue);
                        } else {
                            if ($('[name="' + formDataArray[key].name + '"]').find("input").length > 0 && $('[name="' + formDataArray[key].name + '"]').find("input").attr("type") == "number") {
                                form_data.append(formDataArray[key].name + "_type", "double");
                            }
                            form_data.append(formDataArray[key].name, formDataArray[key].value);
                        }
                    }

                    let btnObj = $(document.activeElement);
                    // if (!$(btnObj).prop("tagName") == "BUTTON") {
                    //     btnObj = $(btnObj).closest("mosaic-button");
                    // } else {
                    //     btnObj = $("#render-canvas button[submit]");
                    // }
                    if (btnObj != null && btnObj.length > 0) {
                        form_data.append($(btnObj).attr("name"), $(btnObj).attr("value"));
                    }
                    if (window.signaturePad) {
                        $.each(window.signaturePad, function () {
                            if (!this.canvas.hasAttribute("data-protected")) {
                                form_data.append(this.canvas.getAttribute("name"), JSON.stringify(this.toData()));
                            }
                        });
                    }
                    e.preventDefault();
                    if (self.isExternal) {
                        let recaptcha = grecaptcha.getResponse();
                        AdminHttpAPI.verifyCaptcha(recaptcha).then(response => {
                            if (response) {
                                self.submitForm(this.formActionURL, form_data);
                            } else {
                                grecaptcha.reset();
                                self.updateCall = true;
                                EventBus.$emit("error-notification", {
                                    msg: "There is a problem with reCaptcha configuration. Please contact system administrator"
                                });
                            }
                        });
                    } else {
                        self.submitForm(this.formActionURL, form_data);
                    }
                } else {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        },
        submitForm(submitURL, formData) {
            let self = this;
            MyProcessListAPI.submitProcessStartForm(submitURL, formData)
                .then(response => {
                    if (response == undefined) {
                        EventBus.$emit('error-notification', {
                            "msg": "Your session has expired, please login again!"
                        });
                        return;
                    } else if (response.status == "success") {
                        if (!self.isExternal) {
                            if (!this.isStandalone) {
                                EventBus.$emit("success-notification", {
                                    msg: response.message
                                });
                            }

                            if (response.nextTaskId != null && response.nextTaskId != "") {
                                if (this.isStandalone) {
                                    self.$router.push(
                                        self.CONTEXT_PATH + "/redirectTo/" + response.nextTaskId
                                    );
                                } else {
                                    self.$router.push(
                                        self.CONTEXT_PATH + "/tasks/viewtask/assigned/" + response.nextTaskId
                                    );
                                }
                            } else {
                                if (this.isStandalone) {
                                    this.$router.push({
                                        path: this.CONTEXT_PATH +
                                            "/standalone/external/process/success",
                                        name: "StartSuccess",
                                        params: {
                                            otherProps: {
                                                completionMessage: response.message,
                                            }
                                        }
                                    });
                                } else {
                                    self.$router.push(self.CONTEXT_PATH + '/category/view/Home');
                                }
                            }
                        } else {
                            this.$router.push({
                                path: this.CONTEXT_PATH +
                                    "/standalone/external/process/success",
                                name: "StartSuccess",
                                params: {
                                    otherProps: {
                                        completionMessage: response.message,
                                    }
                                }
                            });
                        }
                    } else if (
                        response.message == "fileupload.maxsize" ||
                        response.message == "fileupload.scan.error" || response.message == "error.input.owasp.error" || response.message === "fileupload.exe.error"
                    ) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else if (
                        response.message == "startError" ||
                        response.message == "startTaskError"
                    ) {
                        let errorMsg =
                            constantMessages.MESSAGES["home.process.start.fail"];
                        let systemAdminEmail = response.systemAdminEmail;
                        if (systemAdminEmail != null && systemAdminEmail.trim() != "") {
                            errorMsg =
                                constantMessages.MESSAGES["home.process.start.fail.email"];
                            errorMsg = constantMessages.MESSAGES["home.process.start.fail"] +
                                '.<br> <a href="mailto:' +
                                systemAdminEmail +
                                '" target="_top">' +
                                errorMsg +
                                "</a>";
                        }
                        EventBus.$emit("error-notification", {
                            msg: errorMsg
                        });
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        },
        setApiLookupValue(e) {
            APILookupUtils.setApiLookupValue(this.$refs.dataArrayAPI.value);
            this.closeApiLookupValue()
        },
        handlePrintForm() {
            window.print();
        }
    }
};
</script>

<style scoped>
.form-designer-component {
  @import "/formdesigner/css/commonStyles.css";
  @import "/formdesigner/styles.css";
}
</style><style>
#render-canvas .mcc-card .container-fluid,
#render-canvas .mcc-tabs .container-fluid {
    padding: 0;
}
</style>
